export class imageIdToUrlValueConverter {
  toView(value) {
    return '/api/images/'+value;

  }
}
